import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
import { tableCellStyles } from '../styled';
export const StyledTableHeadCell = styled.th `
  ${tableCellStyles};

  height: var(--table-head-cell-height);
  width: ${({ $maxWidth }) => ($maxWidth ? pxToRem($maxWidth) : 'auto')};
  background-color: ${theme.semantic.surface.secondary};
`;
